export default {
  closeMargin: '16px 12px',
  closeSize: '20px',
  closeIconSize: '16px',
  width: '365px',
  padding: '16px',
  titleFontSize: '16px',
  metaFontSize: '12px',
  descriptionFontSize: '12px'
};